import React from "react";

import Banner from "../components/Accounts/Banner";
import AccountTypes from "../components/Accounts/AccountTypes";
import WhyChoose from "../components/Accounts/WhyChoose";
import FAQ from "../components/Accounts/FAQ";
import Assistance from "../components/Home/Assistance";

function AccountsTypes() {
  return (
    <main className="bg-white">
      <Banner />
      <AccountTypes />
      <WhyChoose />
      <FAQ />
      <div className="mt-[80px] xl:mt-[160px]">
        <Assistance />
      </div>
    </main>
  );
}

export default AccountsTypes;
